import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

export const publishersCounter = (originalPublishers: OriginalPublisherModel[]) => {
    let publishersCount = originalPublishers.length

    if (!publishersCount) {
        return 0
    }

    originalPublishers.forEach((op: OriginalPublisherModel) => {
        publishersCount += op.administratorPublishers.length
    })

    return publishersCount
}
